import { getAdapter } from '../../adapters/AdapterManager';
import MessageComposeAdapter from '../../adapters/MessageComposeAdapter';
import { ApiErrorCode } from '../ApiErrorCode';
import { ApiMethodCallback } from '../ApiMethod';
import { createErrorResult } from '../ApiMethodResponseCreator';
import AppendOnSend from '../body/AppendOnSend';
import { CoercionType } from '../setData/CoercionType';
import { SetDataAdapterMethod } from '../setData/SetDataAdapterMethod';
import { SetDataArgs } from '../setData/SetDataArgs';
import setDataAsyncApiMethodBase from '../setData/setDataAsyncApiMethodBase';
import { returnErrorIfUserCannotEditItem } from '../sharedProperties/itemPermissions';
import { getExtensionId } from 'owa-addins-store';
import isItemSendEvent from 'owa-addins-store/lib/store/isItemSendEvent';

export const MAX_BODY_API_LENGTH_FOR_APPEND_ON_SEND = 5000;

export default async function appendOnSendAsyncApiMethod(
    hostItemIndex: string,
    controlId: string,
    args: SetDataArgs,
    callback: ApiMethodCallback
) {
    const data = args.appendTxt;
    // null strings were set to be empty string in API layer, so data should not be null
    if (!!data && data.length > MAX_BODY_API_LENGTH_FOR_APPEND_ON_SEND) {
        callback(createErrorResult(ApiErrorCode.OoeInvalidDataFormat));
        return;
    }

    const adapter: MessageComposeAdapter = getAdapter(hostItemIndex) as MessageComposeAdapter;

    if (returnErrorIfUserCannotEditItem(adapter, callback)) {
        return;
    }

    if (args.coercionType === CoercionType.Html && adapter.getBodyType() === 'Text') {
        callback(createErrorResult(ApiErrorCode.OoeInvalidDataFormat));
        return;
    }

    const extensionId = getExtensionId(controlId);
    if (extensionId == null || isItemSendEvent(extensionId, controlId)) {
        callback(createErrorResult(ApiErrorCode.GenericResponseError));
        return;
    }
    let appendOnSend: AppendOnSend = {
        id: extensionId,
        typ: args.coercionType,
        txt: data, // unsanitized text
    };
    args.appendOnSend = appendOnSend;

    await setDataAsyncApiMethodBase(
        hostItemIndex,
        controlId,
        args,
        callback,
        adapter.appendOnSend as SetDataAdapterMethod
    );
}
